import { pipe, prop } from 'ramda'

const baseLayoutSelector = prop('layout')

export const uiSelector = pipe(baseLayoutSelector, prop('ui'))

export const snackSelector = pipe(uiSelector, prop('snack'))
